<template>
  <div
    class="errorDiv"
    :class="{
      'icj-required': isRequired,
      'icj-required-valid': isRequired && !error,
      'icj-error': error,
    }"
    :id="'itemId' + id + index"
  ></div>
  <div class="block p-5" :class="{ 'mb-5 bg-coral-light': errorMessage }">
    <div class="flex items-center flex-wrap">
      <div class="text-gray-92 leading-4 font-semibold">
        {{ itemName }}
        <span v-if="inputQuestion" class="text-xs ml-1"
          >- {{ inputQuestion }}</span
        >
        <span
          v-if="isRequired"
          class="ml-2"
          style="color: #de2d2d; font-size: 11px"
        >
          必須
        </span>
      </div>
    </div>
    <div v-if="description" class="text-xs my-2 text-gray-62">
      {{ description }}
    </div>

    <div
      class="relative mt-1"
      :class="{
        'w-48': unit,
      }"
      v-click-outside="
        () => {
          showSelect = false;
        }
      "
    >
      <div class="flex items-center">
        <div
          class="border h-10 flex items-center justify-between rounded bg-white px-3 text-gray-92 cursor-pointer w-full body-md"
          :class="{
            'border-danger': errorMessage,
            'border-gray-38': !errorMessage,
            'bg-disabled': disabled,
          }"
          @click="disabled ? null : (showSelect = !showSelect)"
        >
          <div>
            {{
              (items.filter((item) => item.id == inputValueModel).shift() ?? '')
                .name ?? ''
            }}
          </div>
          <img src="@/assets/icons/Select.svg" class="ml-2" />
        </div>
        <span v-if="unit" class="ml-2">{{ unit }}</span>
      </div>
      <div
        v-show="showSelect"
        class="absolute right-0 py-2 bg-white rounded-lg flex flex-col w-full z-10"
        style="box-shadow: 0px 0px 8px rgba(189, 189, 189, 0.5)"
      >
        <div>
          <input
            type="radio"
            :name="'selectradio' + id"
            :id="'itemId' + id + 'optionId'"
            value=""
            v-model="inputValueModel"
            :disabled="disabled"
            :class="[disabled ? 'isDisabled' : 'isNotDisabled']"
          />
          <label
            :for="'itemId' + id + 'optionId'"
            class="block px-4 py-2 text-gray-92 hover:bg-slate-100 cursor-pointer w-full text-left whitespace-no-wrap"
            @click="showSelect = false"
          >
            <span class="ml-2 text-gray-92"></span>
          </label>
        </div>
        <div v-for="item in items" :key="item.id">
          <input
            type="radio"
            :name="'selectradio' + id"
            :id="'itemId' + id + 'optionId' + item.id"
            :data-id="item.id"
            :value="item.id"
            v-model="inputValueModel"
            class="icj-display-on-off"
            :class="[disabled ? 'isDisabled' : 'isNotDisabled']"
          />
          <label
            :for="'itemId' + id + 'optionId' + item.id"
            class="block px-4 py-2 text-gray-92 hover:bg-slate-100 cursor-pointer w-full text-left whitespace-no-wrap"
            @click="showSelect = false"
          >
            <span class="ml-2 text-gray-92 body-md">{{ item.name }}</span>
          </label>
        </div>
      </div>
      <div v-if="errorMessage" class="text-danger text-xs mt-2">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed } from 'vue';
import validateRules from '@/utils/validateRules.js';

export default {
  props: {
    id: Number,
    itemName: String,
    inputQuestion: String,
    description: String,
    rules: String,
    unit: String,
    items: Array,
    inputValue: [Number, String],
    dataType: String,
    disabled: Boolean,
    isSubmit: Boolean,
    index: Number,
  },
  emits: ['update:inputValue'],
  setup(props, { emit }) {
    const state = reactive({
      error: false,
      errorMessage: '',
      showSelect: false,
    });

    const inputValueModel = computed({
      get: () => {
        const result = validateRules.validate(props.inputValue, props.rules);
        if (result === true) {
          state.error = false;
        } else {
          state.error = true;
          if (props.isSubmit) state.errorMessage = result;
        }
        return props.inputValue || '';
      },
      set: (value) => {
        emit('update:inputValue', value);
        const result = validateRules.validate(value, props.rules);
        if (result === true) {
          state.error = false;
          state.errorMessage = '';
        } else {
          state.error = true;
          state.errorMessage = result;
        }
      },
    });

    const isRequired = props.rules.indexOf('required') !== -1;

    return {
      ...toRefs(state),
      inputValueModel,
      isRequired,
    };
  },
};
</script>

<style lang="scss" scoped>
.isNotDisabled {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.isDisabled {
  position: absolute;
  opacity: 0;
}
.errorDiv {
  position: absolute;
  top: -56px;
  left: 0;
}
.bg-disabled {
  background-color: #fafafa;
}
</style>
